import { IReducers } from ".";

/* ------------- Selectors ------------- */
export const carTracker = (state: IReducers) => state.trackCar.snapshotTracker;
